import { render, staticRenderFns } from "./Verifications.vue?vue&type=template&id=32e7e4ec&"
import script from "./Verifications.vue?vue&type=script&lang=js&"
export * from "./Verifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports